import { render, staticRenderFns } from "./HomeNewsList.vue?vue&type=template&id=30d6c606&scoped=true"
import script from "./HomeNewsList.vue?vue&type=script&lang=js"
export * from "./HomeNewsList.vue?vue&type=script&lang=js"
import style0 from "./HomeNewsList.vue?vue&type=style&index=0&id=30d6c606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d6c606",
  null
  
)

export default component.exports